import { postApi } from '@/api';

export class HttpApiListingRepository {
  searchListings(cityId, options) {
    return postApi(`/v1/cities/${encodeURIComponent(cityId)}/listings/search`, options);
  }

  exportListings(cityId, options) {
    return postApi(`/v1/cities/${encodeURIComponent(cityId)}/listings/export`, options);
  }

  async updateListingStatus(cityId, listingId, payload) {
    return postApi(`/v1/cities/${cityId}/listings/${listingId}/status`, payload);
  }
}
